export default "<span *ngFor=\"let path of [].constructor(paths); let pathNumber = index\" class=\"path{{pathNumber + 1}}\"></span>\n";